import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelectedRow } from "../../hooks/advancedTable";
import { AdvancedTableBodyRow } from "./AdvancedTableBodyRow";

export const AdvancedTableBodyRowWrapper = (props) => {
  const { row, updateValue } = props;

  const [data, setData] = useState({});
  const updateValueCallback = useCallback(updateValue, []);
  const selectedRow = useSelectedRow();
  const isSelected = row.UID === selectedRow?.UID;

  const toIgnore = {
    parent: true,
    children: true,
    groupingElements: true,
    indicatorElements: true,
  };

  const isChanged = useMemo(
    () =>
      row.children?.length !== data.children?.length ||
      Object.keys(row)
        .map((key) => ({
          key,
          value: row[key],
        }))
        .some((item) => !toIgnore[item.key] && item.value !== data[item.key]),
    [row?.id]
  );

  useEffect(() => {
    if (isChanged) {
      setData(row);
    }

    return () => {
      setData({});
    };
  }, [row?.id]);

  if (!data.UID) {
    return null;
  }

  return <AdvancedTableBodyRow {...props} updateValue={updateValueCallback} row={data} isSelected={isSelected} />;
};
